module.exports = __webpack_public_path__ + "9ba2c7502273ebd620dbebf13cb71e74.png";


//////////////////
// WEBPACK FOOTER
// ./content/help/research/insilico/scoring-img/img1.png
// module id = 1315
// module chunks = 0